import createAxiosClient from '../utils/api-utils';

/**
 * Photos API - Multi-photo upload management
 */
class PhotosApi {
  constructor() {
    this.client = createAxiosClient();
  }

  /**
   * Generate presigned URL for photo upload
   * @param {number} photoIndex - Which photo slot (0, 1, or 2)
   * @returns {Promise<{uploadUrl: string, photoId: string, photoUrl: string, expiresIn: number}>}
   */
  async generateUploadUrl(photoIndex = 0) {
    return await this.client.post('/photos/upload', { photoIndex });
  }

  /**
   * Mark photo upload as complete
   * @param {number} photoIndex - Which photo slot (0, 1, or 2)
   * @returns {Promise<{message: string, photo: object}>}
   */
  async completeUpload(photoIndex = 0) {
    return await this.client.post('/photos/complete', { photoIndex });
  }

  /**
   * Delete photo from profile
   * @param {number} photoIndex - Which photo slot (0, 1, or 2)
   * @returns {Promise<{message: string, remainingPhotos: number}>}
   */
  async deletePhoto(photoIndex) {
    return await this.client.delete(`/photos/${photoIndex}`);
  }

  /**
   * Upload photo to S3 using presigned URL
   * @param {string} uploadUrl - Presigned S3 URL
   * @param {Blob} file - Image file blob
   * @returns {Promise<Response>}
   */
  async uploadToS3(uploadUrl, file) {
    const response = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': 'image/jpeg'
      }
    });

    if (!response.ok) {
      throw new Error(`S3 upload failed: ${response.statusText}`);
    }

    return response;
  }
}

export default new PhotosApi();
